<template>
    <div class="logo">
        <img
            v-if="!isOandaPath"
            src="https://storage.googleapis.com/oanda-prod-tms-tms-marketing/proxy/images/tms-oanda-logo/tms_oanda_logo.svg"
            alt="Dom Maklerski TMS Brokers"
        />
        <img
            v-if="isOandaPath"
            src="https://storage.googleapis.com/oanda-prod-tms-tms-marketing/proxy/images/oanda-logo/oanda.svg"
            alt="OANDA"
        />
    </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { UtilityHelper } from '@/helpers/UtilityHelper';

export default defineComponent({
    name: 'Logo',
    setup() {
        const isOandaPath = computed(() => UtilityHelper.isOandaPath());

        return {
            isOandaPath,
        };
    },
});
</script>
